const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/notifications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/notifications/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/notifications/")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tNotif = createTranslator({
      locale,
      messages,
      namespace: "globals.notifications"
    });
    return {
      meta: buildPrivatePageMetaTags(tNotif("title"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});